import React from 'react';
import { useRenderControl } from '../../context/InstallerRenderControlContext';
export const LoadingDependentWrapper = _ref => {
  let {
    children
  } = _ref;
  const {
    isLoadingInstaller
  } = useRenderControl();
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: isLoadingInstaller ? 'none' : 'unset'
    }
  }, children);
};
//# sourceMappingURL=LoadingDependentWrapper.js.map